import { ARRAY_OF_INSTRUMENTS_01 } from '../../mocks/instruments.data';
import { concat, NEVER, Observable, of } from 'rxjs';
import { IAllAvailableInstrumentsService } from './all-available-instruments.interface';
import { IInstrument } from '../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class AllAvailableInstrumentsMock implements IAllAvailableInstrumentsService {
    asObservable(): Observable<Array<IInstrument>> {
        return concat(of(ARRAY_OF_INSTRUMENTS_01), NEVER);
    }
}
